// ----------------------------------------------------------------------- externos
import { Link, Outlet } from "react-router-dom";

// ----------------------------------------------------------------------- internos
import { useAuth } from "../../auth/AuthContext";
import { MARCA_LARGA } from "../../marca";
// UAT: con sesión va el MISMO armazón que el resto del hub (barra o rail, con
// el tema elegido). Con `Layout` a secas, «Cómo se usa» saltaba al rail viejo
// sin tema (Igna: «lo rompe completamente»).
import LayoutSwitcher from "./LayoutSwitcher";
import "../../assets/css/marco-abierto.css";

/* El marco de las pantallas ABIERTAS: las que se pueden leer sin cuenta.
 *
 * Hoy hay una sola, `/ayuda`, y es la que se manda por mail junto con la clave
 * provisoria. Ahí está el problema que esto resuelve: quien abre ese enlace
 * TODAVÍA NO ENTRÓ NUNCA. Pedirle sesión a la página que explica cómo entrar
 * es un círculo — y peor, no se ve como un círculo: el guard redirige al
 * login y la persona se queda con que "el link no anda".
 *
 * PERO NO ES UNA PÁGINA SUELTA. Al que sí tiene sesión hay que dibujarle el
 * hub completo: "Cómo se usa" está en el menú, y que al tocarlo desaparezca el
 * menú se lee como haberse ido del sistema. Por eso esto ELIGE el marco en vez
 * de reemplazarlo — con sesión es el hub de siempre, sin sesión es una página
 * que se lee y ofrece entrar.
 *
 * MIENTRAS SE RESTAURA LA SESIÓN se muestra el marco abierto, no una pantalla
 * en blanco: el contenido es el mismo en los dos casos y es texto, así que
 * conviene que esté a la vista desde el primer instante. Si termina habiendo
 * sesión, aparece el rail alrededor. Al revés —esperar en blanco a saber— la
 * página tarda en aparecer justo para quien no tiene cuenta, que es a quien
 * está dirigida.
 */

const MarcoAbierto = () => {
  const { isAuthenticated, loading } = useAuth();

  if (isAuthenticated && !loading) return <LayoutSwitcher />;

  return (
    <div className="abierto">
      <header className="abierto-tapa">
        <span className="abierto-marca">{MARCA_LARGA}</span>
        <Link className="abierto-entrar" to="/login">
          Entrar
        </Link>
      </header>
      <main className="abierto-main">
        <Outlet />
      </main>
    </div>
  );
};

export default MarcoAbierto;
